export class DocumentRef{
    public id:number;
    public name:string;
    public description:string;
    public required:boolean;
    public fileIndex?:number;
    public receipt?: string;
    public fileId?: number;
}
